import React from 'react';
import '../styles/EmbodimentChoiceModal.css';

function EmbodimentChoiceModal({ isOpen, title, onChoose, onClose, availableDukes, side }) {
  if (!isOpen) return null;
  
  // Determine Duke positions and their embodiment modes
  // c1/c8 (position 2/58) = Instant King Duke
  // f1/f8 (position 5/61) = Fight to be King Duke
  const instantKingPos = side === 'white' ? 2 : 58;  // c1 or c8
  const fightPos = side === 'white' ? 5 : 61;  // f1 or f8
  
  const hasInstantDuke = availableDukes && availableDukes.includes(instantKingPos);
  const hasFightDuke = availableDukes && availableDukes.includes(fightPos);
  
  return (
    <div className="embodiment-modal-overlay" onClick={onClose}>
      <div className="embodiment-modal" onClick={(e) => e.stopPropagation()}>
        <h2>{title}</h2>
        <p className="modal-instruction">Choose which Duke should become King:</p>
        
        <div className="embodiment-options">
          {hasInstantDuke && (
            <button 
              className="embodiment-button instant-king"
              onClick={() => onChoose(instantKingPos)}
            >
              <div className="embodiment-icon">⚡</div>
              <div className="embodiment-title">Instant King Duke</div>
              <div className="embodiment-position">Position: {side === 'white' ? 'c1' : 'c8'} (beside Queen)</div>
              <div className="embodiment-description">
                Transforms immediately into a King
              </div>
            </button>
          )}
          
          {hasFightDuke && (
            <button 
              className="embodiment-button fight-to-king"
              onClick={() => onChoose(fightPos)}
            >
              <div className="embodiment-icon">⚔️</div>
              <div className="embodiment-title">Fight to be King Duke</div>
              <div className="embodiment-position">Position: {side === 'white' ? 'f1' : 'f8'} (beside King)</div>
              <div className="embodiment-description">
                Must return to baseline ({side === 'white' ? 'rank 1' : 'rank 8'}) to transform
              </div>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default EmbodimentChoiceModal;
